import { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import md5 from 'md5';
import { showError } from 'utils/utils';
import Button from 'components/ui/Button/Button';
import FormGroup from 'components/ui/FormGroup/FormGroup';
import ScreenshotSupport from './ScreenshotSupport';
import MaximizeModal from './MaximizeModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import useDraggableModal from 'hooks/useDraggableModal';

interface BookSecretProps {
  onClose: () => void;
  onSuccess: () => void;
}

const BookSecret: FC<BookSecretProps> = ({ onClose, onSuccess }) => {
  const [t] = useTranslation();
  const modalOverlayRef = useRef<HTMLDivElement>(null);
  const [password, setPassword] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);

  const onClickSubmit = () => {
    const hash = 'e9137a47118a595eaaeb012c2e7ce78e';
    setIsSubmitted(true);

    if (md5(password) === hash) {
      onSuccess();
    } else {
      showError(t('home.wrong_password'));
    }
  };

  return (
    <div className="modal-overlay modal-overlay-top modal-maximizable" ref={modalOverlayRef}>
      <div ref={modalRef} className="modal modal-sm active" style={modalStyle}>
        <div
          className={'modal-title draggable-modal-handle' + (isDragging ? ' dragging' : '')}
          {...dragHandleProps}
        >
          <h5 className="title">{t('home.confirmation_dialog')}</h5>{' '}
          <div data-no-drag="true">
            <ScreenshotSupport />
            <MaximizeModal modalOverlayRef={modalOverlayRef} />
            <FontAwesomeIcon icon={faTimes} onClick={() => onClose()} />
          </div>
        </div>
        <div className="modal-content">
          <FormGroup
            onChange={setPassword}
            value={password}
            label={t('home.password')}
            validation={{ required: true }}
            isSubmitted={isSubmitted}
          />
        </div>
        <div className="modal-footer">
          <Button
            className="btn btn-primary mr-a ml-0"
            title={t('confirm')}
            onClick={() => onClickSubmit()}
          />
          <Button title={t('close')} className="btn btn-default" onClick={() => onClose()} />
        </div>
      </div>
    </div>
  );
};

export default BookSecret;
